var t;!function(t){t[t.maxStartAmount=999999999]="maxStartAmount",t[t.minStartAmount=500]="minStartAmount",t[t.maxMonthlyAmount=1e4]="maxMonthlyAmount",t[t.minMonthlyAmount=50]="minMonthlyAmount"}(t||(t={}));export{t as SavingAmounts};
//# sourceMappingURL=types.js.map
